import { r as e, t } from "./rolldown-runtime-jwUa06l-.js";
import { Jr as n, qr as r } from "./@global-configuration-CBGz_rZL.js";
import i, { useCallback as a, useEffect as o, useMemo as s, useRef as c, useState as l } from "react";
import * as u from "react-dom";
import './assets/@vendor.css';//#region node_modules/fast-json-patch/module/helpers.mjs
var d = (function() {
	var e = function(t, n) {
		return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
			e.__proto__ = t;
		} || function(e, t) {
			for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
		}, e(t, n);
	};
	return function(t, n) {
		e(t, n);
		function r() {
			this.constructor = t;
		}
		t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
	};
})(), f = Object.prototype.hasOwnProperty;
function p(e, t) {
	return f.call(e, t);
}
function m(e) {
	if (Array.isArray(e)) {
		for (var t = Array(e.length), n = 0; n < t.length; n++) t[n] = "" + n;
		return t;
	}
	if (Object.keys) return Object.keys(e);
	var r = [];
	for (var i in e) p(e, i) && r.push(i);
	return r;
}
function h(e) {
	switch (typeof e) {
		case "object": return JSON.parse(JSON.stringify(e));
		case "undefined": return null;
		default: return e;
	}
}
function g(e) {
	for (var t = 0, n = e.length, r; t < n;) {
		if (r = e.charCodeAt(t), r >= 48 && r <= 57) {
			t++;
			continue;
		}
		return !1;
	}
	return !0;
}
function _(e) {
	return e.indexOf("/") === -1 && e.indexOf("~") === -1 ? e : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function v(e) {
	return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
function y(e) {
	if (e === void 0) return !0;
	if (e) {
		if (Array.isArray(e)) {
			for (var t = 0, n = e.length; t < n; t++) if (y(e[t])) return !0;
		} else if (typeof e == "object") {
			for (var r = m(e), i = r.length, a = 0; a < i; a++) if (y(e[r[a]])) return !0;
		}
	}
	return !1;
}
function b(e, t) {
	var n = [e];
	for (var r in t) {
		var i = typeof t[r] == "object" ? JSON.stringify(t[r], null, 2) : t[r];
		i !== void 0 && n.push(r + ": " + i);
	}
	return n.join("\n");
}
var x = function(e) {
	d(t, e);
	function t(t, n, r, i, a) {
		var o = this.constructor, s = e.call(this, b(t, {
			name: n,
			index: r,
			operation: i,
			tree: a
		})) || this;
		return s.name = n, s.index = r, s.operation = i, s.tree = a, Object.setPrototypeOf(s, o.prototype), s.message = b(t, {
			name: n,
			index: r,
			operation: i,
			tree: a
		}), s;
	}
	return t;
}(Error), S = /* @__PURE__ */ e({
	JsonPatchError: () => C,
	_areEquals: () => j,
	applyOperation: () => E,
	applyPatch: () => D,
	applyReducer: () => O,
	deepClone: () => ee,
	getValueByPointer: () => T,
	validate: () => A,
	validator: () => k
}), C = x, ee = h, w = {
	add: function(e, t, n) {
		return e[t] = this.value, { newDocument: n };
	},
	remove: function(e, t, n) {
		var r = e[t];
		return delete e[t], {
			newDocument: n,
			removed: r
		};
	},
	replace: function(e, t, n) {
		var r = e[t];
		return e[t] = this.value, {
			newDocument: n,
			removed: r
		};
	},
	move: function(e, t, n) {
		var r = T(n, this.path);
		r &&= h(r);
		var i = E(n, {
			op: "remove",
			path: this.from
		}).removed;
		return E(n, {
			op: "add",
			path: this.path,
			value: i
		}), {
			newDocument: n,
			removed: r
		};
	},
	copy: function(e, t, n) {
		var r = T(n, this.from);
		return E(n, {
			op: "add",
			path: this.path,
			value: h(r)
		}), { newDocument: n };
	},
	test: function(e, t, n) {
		return {
			newDocument: n,
			test: j(e[t], this.value)
		};
	},
	_get: function(e, t, n) {
		return this.value = e[t], { newDocument: n };
	}
}, te = {
	add: function(e, t, n) {
		return g(t) ? e.splice(t, 0, this.value) : e[t] = this.value, {
			newDocument: n,
			index: t
		};
	},
	remove: function(e, t, n) {
		return {
			newDocument: n,
			removed: e.splice(t, 1)[0]
		};
	},
	replace: function(e, t, n) {
		var r = e[t];
		return e[t] = this.value, {
			newDocument: n,
			removed: r
		};
	},
	move: w.move,
	copy: w.copy,
	test: w.test,
	_get: w._get
};
function T(e, t) {
	if (t == "") return e;
	var n = {
		op: "_get",
		path: t
	};
	return E(e, n), n.value;
}
function E(e, t, n, r, i, a) {
	if (n === void 0 && (n = !1), r === void 0 && (r = !0), i === void 0 && (i = !0), a === void 0 && (a = 0), n && (typeof n == "function" ? n(t, 0, e, t.path) : k(t, 0)), t.path === "") {
		var o = { newDocument: e };
		if (t.op === "add") return o.newDocument = t.value, o;
		if (t.op === "replace") return o.newDocument = t.value, o.removed = e, o;
		if (t.op === "move" || t.op === "copy") return o.newDocument = T(e, t.from), t.op === "move" && (o.removed = e), o;
		if (t.op === "test") {
			if (o.test = j(e, t.value), o.test === !1) throw new C("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
			return o.newDocument = e, o;
		} else if (t.op === "remove") return o.removed = e, o.newDocument = null, o;
		else if (t.op === "_get") return t.value = e, o;
		else if (n) throw new C("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", a, t, e);
		else return o;
	} else {
		r || (e = h(e));
		var s = (t.path || "").split("/"), c = e, l = 1, u = s.length, d = void 0, f = void 0, p = void 0;
		for (p = typeof n == "function" ? n : k;;) {
			if (f = s[l], f && f.indexOf("~") != -1 && (f = v(f)), i && (f == "__proto__" || f == "prototype" && l > 0 && s[l - 1] == "constructor")) throw TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
			if (n && d === void 0 && (c[f] === void 0 ? d = s.slice(0, l).join("/") : l == u - 1 && (d = t.path), d !== void 0 && p(t, 0, e, d)), l++, Array.isArray(c)) {
				if (f === "-") f = c.length;
				else if (n && !g(f)) throw new C("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", a, t, e);
				else g(f) && (f = ~~f);
				if (l >= u) {
					if (n && t.op === "add" && f > c.length) throw new C("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", a, t, e);
					var o = te[t.op].call(t, c, f, e);
					if (o.test === !1) throw new C("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
					return o;
				}
			} else if (l >= u) {
				var o = w[t.op].call(t, c, f, e);
				if (o.test === !1) throw new C("Test operation failed", "TEST_OPERATION_FAILED", a, t, e);
				return o;
			}
			if (c = c[f], n && l < u && (!c || typeof c != "object")) throw new C("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", a, t, e);
		}
	}
}
function D(e, t, n, r, i) {
	if (r === void 0 && (r = !0), i === void 0 && (i = !0), n && !Array.isArray(t)) throw new C("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
	r || (e = h(e));
	for (var a = Array(t.length), o = 0, s = t.length; o < s; o++) a[o] = E(e, t[o], n, !0, i, o), e = a[o].newDocument;
	return a.newDocument = e, a;
}
function O(e, t, n) {
	var r = E(e, t);
	if (r.test === !1) throw new C("Test operation failed", "TEST_OPERATION_FAILED", n, t, e);
	return r.newDocument;
}
function k(e, t, n, r) {
	if (typeof e != "object" || !e || Array.isArray(e)) throw new C("Operation is not an object", "OPERATION_NOT_AN_OBJECT", t, e, n);
	if (!w[e.op]) throw new C("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", t, e, n);
	if (typeof e.path != "string") throw new C("Operation `path` property is not a string", "OPERATION_PATH_INVALID", t, e, n);
	if (e.path.indexOf("/") !== 0 && e.path.length > 0) throw new C("Operation `path` property must start with \"/\"", "OPERATION_PATH_INVALID", t, e, n);
	if ((e.op === "move" || e.op === "copy") && typeof e.from != "string") throw new C("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", t, e, n);
	if ((e.op === "add" || e.op === "replace" || e.op === "test") && e.value === void 0) throw new C("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", t, e, n);
	if ((e.op === "add" || e.op === "replace" || e.op === "test") && y(e.value)) throw new C("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", t, e, n);
	if (n) {
		if (e.op == "add") {
			var i = e.path.split("/").length, a = r.split("/").length;
			if (i !== a + 1 && i !== a) throw new C("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", t, e, n);
		} else if (e.op === "replace" || e.op === "remove" || e.op === "_get") {
			if (e.path !== r) throw new C("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", t, e, n);
		} else if (e.op === "move" || e.op === "copy") {
			var o = A([{
				op: "_get",
				path: e.from,
				value: void 0
			}], n);
			if (o && o.name === "OPERATION_PATH_UNRESOLVABLE") throw new C("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", t, e, n);
		}
	}
}
function A(e, t, n) {
	try {
		if (!Array.isArray(e)) throw new C("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
		if (t) D(h(t), h(e), n || !0);
		else {
			n ||= k;
			for (var r = 0; r < e.length; r++) n(e[r], r, t, void 0);
		}
	} catch (e) {
		if (e instanceof C) return e;
		throw e;
	}
}
function j(e, t) {
	if (e === t) return !0;
	if (e && t && typeof e == "object" && typeof t == "object") {
		var n = Array.isArray(e), r = Array.isArray(t), i, a, o;
		if (n && r) {
			if (a = e.length, a != t.length) return !1;
			for (i = a; i-- !== 0;) if (!j(e[i], t[i])) return !1;
			return !0;
		}
		if (n != r) return !1;
		var s = Object.keys(e);
		if (a = s.length, a !== Object.keys(t).length) return !1;
		for (i = a; i-- !== 0;) if (!t.hasOwnProperty(s[i])) return !1;
		for (i = a; i-- !== 0;) if (o = s[i], !j(e[o], t[o])) return !1;
		return !0;
	}
	return e !== e && t !== t;
}
//#endregion
//#region node_modules/fast-json-patch/module/duplex.mjs
var ne = /* @__PURE__ */ e({
	compare: () => ce,
	generate: () => oe,
	observe: () => I,
	unobserve: () => ae
}), M = /* @__PURE__ */ new WeakMap(), N = function() {
	function e(e) {
		this.observers = /* @__PURE__ */ new Map(), this.obj = e;
	}
	return e;
}(), re = function() {
	function e(e, t) {
		this.callback = e, this.observer = t;
	}
	return e;
}();
function P(e) {
	return M.get(e);
}
function F(e, t) {
	return e.observers.get(t);
}
function ie(e, t) {
	e.observers.delete(t.callback);
}
function ae(e, t) {
	t.unobserve();
}
function I(e, t) {
	var n = [], r, i = P(e);
	if (!i) i = new N(e), M.set(e, i);
	else {
		var a = F(i, t);
		r = a && a.observer;
	}
	if (r) return r;
	if (r = {}, i.value = h(e), t) {
		r.callback = t, r.next = null;
		var o = function() {
			oe(r);
		}, s = function() {
			clearTimeout(r.next), r.next = setTimeout(o);
		};
		typeof window < "u" && (window.addEventListener("mouseup", s), window.addEventListener("keyup", s), window.addEventListener("mousedown", s), window.addEventListener("keydown", s), window.addEventListener("change", s));
	}
	return r.patches = n, r.object = e, r.unobserve = function() {
		oe(r), clearTimeout(r.next), ie(i, r), typeof window < "u" && (window.removeEventListener("mouseup", s), window.removeEventListener("keyup", s), window.removeEventListener("mousedown", s), window.removeEventListener("keydown", s), window.removeEventListener("change", s));
	}, i.observers.set(t, new re(t, r)), r;
}
function oe(e, t) {
	t === void 0 && (t = !1);
	var n = M.get(e.object);
	se(n.value, e.object, e.patches, "", t), e.patches.length && D(n.value, e.patches);
	var r = e.patches;
	return r.length > 0 && (e.patches = [], e.callback && e.callback(r)), r;
}
function se(e, t, n, r, i) {
	if (t !== e) {
		typeof t.toJSON == "function" && (t = t.toJSON());
		for (var a = m(t), o = m(e), s = !1, c = o.length - 1; c >= 0; c--) {
			var l = o[c], u = e[l];
			if (p(t, l) && !(t[l] === void 0 && u !== void 0 && Array.isArray(t) === !1)) {
				var d = t[l];
				typeof u == "object" && u && typeof d == "object" && d && Array.isArray(u) === Array.isArray(d) ? se(u, d, n, r + "/" + _(l), i) : u !== d && (i && n.push({
					op: "test",
					path: r + "/" + _(l),
					value: h(u)
				}), n.push({
					op: "replace",
					path: r + "/" + _(l),
					value: h(d)
				}));
			} else Array.isArray(e) === Array.isArray(t) ? (i && n.push({
				op: "test",
				path: r + "/" + _(l),
				value: h(u)
			}), n.push({
				op: "remove",
				path: r + "/" + _(l)
			}), s = !0) : (i && n.push({
				op: "test",
				path: r,
				value: e
			}), n.push({
				op: "replace",
				path: r,
				value: t
			}));
		}
		if (!(!s && a.length == o.length)) for (var c = 0; c < a.length; c++) {
			var l = a[c];
			!p(e, l) && t[l] !== void 0 && n.push({
				op: "add",
				path: r + "/" + _(l),
				value: h(t[l])
			});
		}
	}
}
function ce(e, t, n) {
	n === void 0 && (n = !1);
	var r = [];
	return se(e, t, r, "", n), r;
}
Object.assign({}, S, ne, {
	JsonPatchError: x,
	deepClone: h,
	escapePathComponent: _,
	unescapePathComponent: v
});
//#endregion
//#region node_modules/react-grid-layout/dist/chunk-76RTO6EO.mjs
function le(e) {
	let { margin: t, containerPadding: n, containerWidth: r, cols: i } = e;
	return (r - t[0] * (i - 1) - n[0] * 2) / i;
}
function L(e, t, n) {
	return Number.isFinite(e) ? Math.round(t * e + Math.max(0, e - 1) * n) : e;
}
function ue(e, t, n, r, i, a, o) {
	let { margin: s, containerPadding: c, rowHeight: l } = e, u = le(e), d, f, p, m;
	if (o ? (d = Math.round(o.width), f = Math.round(o.height)) : (d = L(r, u, s[0]), f = L(i, l, s[1])), a ? (p = Math.round(a.top), m = Math.round(a.left)) : o ? (p = Math.round(o.top), m = Math.round(o.left)) : (p = Math.round((l + s[1]) * n + c[1]), m = Math.round((u + s[0]) * t + c[0])), !a && !o) {
		if (Number.isFinite(r)) {
			let e = Math.round((u + s[0]) * (t + r) + c[0]) - m - d;
			e !== s[0] && (d += e - s[0]);
		}
		if (Number.isFinite(i)) {
			let e = Math.round((l + s[1]) * (n + i) + c[1]) - p - f;
			e !== s[1] && (f += e - s[1]);
		}
	}
	return {
		top: p,
		left: m,
		width: d,
		height: f
	};
}
function de(e, t, n, r, i) {
	let { margin: a, containerPadding: o, cols: s, rowHeight: c, maxRows: l } = e, u = le(e), d = Math.round((n - o[0]) / (u + a[0])), f = Math.round((t - o[1]) / (c + a[1]));
	return d = me(d, 0, s - r), f = me(f, 0, l - i), {
		x: d,
		y: f
	};
}
function fe(e, t, n) {
	let { margin: r, containerPadding: i, rowHeight: a } = e, o = le(e);
	return {
		x: Math.round((n - i[0]) / (o + r[0])),
		y: Math.round((t - i[1]) / (a + r[1]))
	};
}
function pe(e, t, n) {
	let { margin: r, rowHeight: i } = e, a = le(e);
	return {
		w: Math.max(1, Math.round((t + r[0]) / (a + r[0]))),
		h: Math.max(1, Math.round((n + r[1]) / (i + r[1])))
	};
}
function me(e, t, n) {
	return Math.max(Math.min(e, n), t);
}
function he(e, t) {
	return !(e.i === t.i || e.x + e.w <= t.x || e.x >= t.x + t.w || e.y + e.h <= t.y || e.y >= t.y + t.h);
}
function R(e, t) {
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r !== void 0 && he(r, t)) return r;
	}
}
function ge(e, t) {
	return e.filter((e) => he(e, t));
}
function z(e, t) {
	return t === "horizontal" ? V(e) : t === "vertical" || t === "wrap" ? B(e) : [...e];
}
function B(e) {
	return [...e].sort((e, t) => e.y === t.y ? e.x - t.x : e.y - t.y);
}
function V(e) {
	return [...e].sort((e, t) => e.x === t.x ? e.y - t.y : e.x - t.x);
}
function H(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r !== void 0) {
			let e = r.y + r.h;
			e > t && (t = e);
		}
	}
	return t;
}
function _e(e, t) {
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (r !== void 0 && r.i === t) return r;
	}
}
function U(e) {
	return e.filter((e) => e.static === !0);
}
function ve(e) {
	return {
		i: e.i,
		x: e.x,
		y: e.y,
		w: e.w,
		h: e.h,
		minW: e.minW,
		maxW: e.maxW,
		minH: e.minH,
		maxH: e.maxH,
		moved: !!e.moved,
		static: !!e.static,
		isDraggable: e.isDraggable,
		isResizable: e.isResizable,
		resizeHandles: e.resizeHandles,
		constraints: e.constraints,
		isBounded: e.isBounded
	};
}
function ye(e) {
	let t = Array(e.length);
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		r !== void 0 && (t[n] = ve(r));
	}
	return t;
}
function be(e, t) {
	let n = Array(e.length);
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		i !== void 0 && (t.i === i.i ? n[r] = t : n[r] = i);
	}
	return n;
}
function xe(e, t, n) {
	let r = _e(e, t);
	return r ? (r = n(ve(r)), [be(e, r), r]) : [[...e], null];
}
function W(e, t) {
	let n = U(e);
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		if (i !== void 0) if (i.x + i.w > t.cols && (i.x = t.cols - i.w), i.x < 0 && (i.x = 0, i.w = t.cols), !i.static) n.push(i);
		else for (; R(n, i);) i.y++;
	}
	return e;
}
function G(e, t, n, r, i, a, o, s, c) {
	if (t.static && t.isDraggable !== !0 || t.y === r && t.x === n) return [...e];
	let l = t.x, u = t.y;
	typeof n == "number" && (t.x = n), typeof r == "number" && (t.y = r), t.moved = !0;
	let d = z(e, o);
	(o === "vertical" && typeof r == "number" ? u >= r : o === "horizontal" && typeof n == "number" && l >= n) && (d = d.reverse());
	let f = ge(d, t), p = f.length > 0;
	if (p && c) return ye(e);
	if (p && a) return t.x = l, t.y = u, t.moved = !1, e;
	let m = [...e];
	for (let e = 0; e < f.length; e++) {
		let n = f[e];
		n !== void 0 && (n.moved || (m = n.static ? K(m, n, t, i, o) : K(m, t, n, i, o)));
	}
	return m;
}
function K(e, t, n, r, i, a) {
	let o = i === "horizontal", s = i === "vertical", c = t.static;
	if (r) {
		r = !1;
		let a = {
			x: o ? Math.max(t.x - n.w, 0) : n.x,
			y: s ? Math.max(t.y - n.h, 0) : n.y,
			w: n.w,
			h: n.h,
			i: "-1"
		}, l = R(e, a), u = l !== void 0 && l.y + l.h > t.y, d = l !== void 0 && t.x + t.w > l.x;
		if (!l) return G(e, n, o ? a.x : void 0, s ? a.y : void 0, r, c, i);
		if (u && s) return G(e, n, void 0, n.y + 1, r, c, i);
		if (u && i === null) return t.y = n.y, n.y += n.h, [...e];
		if (d && o) return G(e, t, n.x, void 0, r, c, i);
	}
	let l = o ? n.x + 1 : void 0, u = s ? n.y + 1 : void 0;
	return l === void 0 && u === void 0 ? [...e] : G(e, n, l, u, r, c, i);
}
//#endregion
//#region node_modules/react-grid-layout/dist/chunk-KDANGDDL.mjs
function Se(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
var Ce = [{
	name: "gridBounds",
	constrainPosition(e, t, n, { cols: r, maxRows: i }) {
		return {
			x: Se(t, 0, Math.max(0, r - e.w)),
			y: Se(n, 0, Math.max(0, i - e.h))
		};
	},
	constrainSize(e, t, n, r, { cols: i, maxRows: a }) {
		let o = r === "w" || r === "nw" || r === "sw" ? e.x + e.w : i - e.x, s = r === "n" || r === "nw" || r === "ne" ? e.y + e.h : a - e.y;
		return {
			w: Se(t, 1, Math.max(1, o)),
			h: Se(n, 1, Math.max(1, s))
		};
	}
}, {
	name: "minMaxSize",
	constrainSize(e, t, n) {
		return {
			w: Se(t, e.minW ?? 1, e.maxW ?? Infinity),
			h: Se(n, e.minH ?? 1, e.maxH ?? Infinity)
		};
	}
}];
function q(e, t, n, r, i) {
	let a = {
		x: n,
		y: r
	};
	for (let n of e) n.constrainPosition && (a = n.constrainPosition(t, a.x, a.y, i));
	if (t.constraints) for (let e of t.constraints) e.constrainPosition && (a = e.constrainPosition(t, a.x, a.y, i));
	return a;
}
function we(e, t, n, r, i, a) {
	let o = {
		w: n,
		h: r
	};
	for (let n of e) n.constrainSize && (o = n.constrainSize(t, o.w, o.h, i, a));
	if (t.constraints) for (let e of t.constraints) e.constrainSize && (o = e.constrainSize(t, o.w, o.h, i, a));
	return o;
}
function J({ top: e, left: t, width: n, height: r }) {
	let i = `translate(${t}px,${e}px)`;
	return {
		transform: i,
		WebkitTransform: i,
		MozTransform: i,
		msTransform: i,
		OTransform: i,
		width: `${n}px`,
		height: `${r}px`,
		position: "absolute"
	};
}
function Te({ top: e, left: t, width: n, height: r }) {
	return {
		top: `${e}px`,
		left: `${t}px`,
		width: `${n}px`,
		height: `${r}px`,
		position: "absolute"
	};
}
function Ee(e) {
	return e * 100 + "%";
}
function Y(e, t, n, r) {
	return e + n > r ? t : n;
}
function X(e, t, n) {
	return e < 0 ? t : n;
}
function De(e) {
	return Math.max(0, e);
}
function Z(e) {
	return Math.max(0, e);
}
var Oe = (e, t, n) => {
	let { left: r, height: i, width: a } = t, o = e.top - (i - e.height);
	return {
		left: r,
		width: a,
		height: X(o, e.height, i),
		top: Z(o)
	};
}, ke = (e, t, n) => {
	let { top: r, left: i, height: a, width: o } = t;
	return {
		top: r,
		height: a,
		width: Y(e.left, e.width, o, n),
		left: De(i)
	};
}, Q = (e, t, n) => {
	let { top: r, height: i, width: a } = t, o = e.left + e.width - a;
	return o < 0 ? {
		height: i,
		width: e.left + e.width,
		top: Z(r),
		left: 0
	} : {
		height: i,
		width: a,
		top: Z(r),
		left: o
	};
}, Ae = (e, t, n) => {
	let { top: r, left: i, height: a, width: o } = t;
	return {
		width: o,
		left: i,
		height: X(r, e.height, a),
		top: Z(r)
	};
}, je = {
	n: Oe,
	ne: (e, t, n) => Oe(e, ke(e, t, n)),
	e: ke,
	se: (e, t, n) => Ae(e, ke(e, t, n)),
	s: Ae,
	sw: (e, t, n) => Ae(e, Q(e, t)),
	w: Q,
	nw: (e, t, n) => Oe(e, Q(e, t))
};
function Me(e, t, n, r) {
	let i = je[e];
	return i ? i(t, {
		...t,
		...n
	}, r) : n;
}
var Ne = {
	type: "transform",
	scale: 1,
	calcStyle(e) {
		return J(e);
	}
}, Pe = {
	cols: 12,
	rowHeight: 150,
	margin: [10, 10],
	containerPadding: null,
	maxRows: Infinity
}, Fe = {
	enabled: !0,
	bounded: !1,
	threshold: 3
}, Ie = {
	enabled: !0,
	handles: ["se"]
}, Le = {
	enabled: !1,
	defaultItem: {
		w: 1,
		h: 1
	}
};
function Re(e, t, n, r, i) {
	let a = r === "x" ? "w" : "h";
	t[r] += 1;
	let o = e.findIndex((e) => e.i === t.i), s = i ?? U(e).length > 0;
	for (let i = o + 1; i < e.length; i++) {
		let o = e[i];
		if (o !== void 0 && !o.static) {
			if (!s && o.y > t.y + t.h) break;
			he(t, o) && Re(e, o, n + t[a], r, s);
		}
	}
	t[r] = n;
}
function ze(e, t, n, r) {
	for (t.x = Math.max(t.x, 0), t.y = Math.max(t.y, 0), t.y = Math.min(r, t.y); t.y > 0 && !R(e, t);) t.y--;
	let i;
	for (; (i = R(e, t)) !== void 0;) Re(n, t, i.y + i.h, "y");
	return t.y = Math.max(t.y, 0), t;
}
function Be(e, t, n, r) {
	for (t.x = Math.max(t.x, 0), t.y = Math.max(t.y, 0); t.x > 0 && !R(e, t);) t.x--;
	let i;
	for (; (i = R(e, t)) !== void 0;) if (Re(r, t, i.x + i.w, "x"), t.x + t.w > n) for (t.x = n - t.w, t.y++; t.x > 0 && !R(e, t);) t.x--;
	return t.x = Math.max(t.x, 0), t;
}
var $ = {
	type: "vertical",
	allowOverlap: !1,
	compact(e, t) {
		let n = U(e), r = H(n), i = B(e), a = Array(e.length);
		for (let t = 0; t < i.length; t++) {
			let o = i[t];
			if (o === void 0) continue;
			let s = ve(o);
			s.static || (s = ze(n, s, i, r), r = Math.max(r, s.y + s.h), n.push(s));
			let c = e.indexOf(o);
			a[c] = s, s.moved = !1;
		}
		return a;
	}
}, Ve = {
	type: "horizontal",
	allowOverlap: !1,
	compact(e, t) {
		let n = U(e), r = V(e), i = Array(e.length);
		for (let a = 0; a < r.length; a++) {
			let o = r[a];
			if (o === void 0) continue;
			let s = ve(o);
			s.static || (s = Be(n, s, t, r), n.push(s));
			let c = e.indexOf(o);
			i[c] = s, s.moved = !1;
		}
		return i;
	}
}, He = {
	type: null,
	allowOverlap: !1,
	compact(e, t) {
		return ye(e);
	}
}, Ue = {
	...$,
	allowOverlap: !0,
	compact(e, t) {
		return ye(e);
	}
}, We = {
	...Ve,
	allowOverlap: !0,
	compact(e, t) {
		return ye(e);
	}
}, Ge = {
	...He,
	allowOverlap: !0
};
function Ke(e, t = !1, n = !1) {
	let r;
	return r = t ? e === "vertical" ? Ue : e === "horizontal" ? We : Ge : e === "vertical" ? $ : e === "horizontal" ? Ve : He, n ? {
		...r,
		preventCollision: n
	} : r;
}
//#endregion
//#region node_modules/fast-equals/dist/fast-equals.js
var qe = /* @__PURE__ */ t(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? r(e) : typeof define == "function" && define.amd ? define(["exports"], r) : (n = typeof globalThis < "u" ? globalThis : n || self, r(n["fast-equals"] = {}));
	})(e, (function(e) {
		function t(e) {
			return function(t, n, r, i, a, o, s) {
				return e(t, n, s);
			};
		}
		function n(e) {
			return function(t, n, r, i) {
				if (!t || !n || typeof t != "object" || typeof n != "object") return e(t, n, r, i);
				var a = i.get(t), o = i.get(n);
				if (a && o) return a === n && o === t;
				i.set(t, n), i.set(n, t);
				var s = e(t, n, r, i);
				return i.delete(t), i.delete(n), s;
			};
		}
		function r(e, t) {
			var n = {};
			for (var r in e) n[r] = e[r];
			for (var r in t) n[r] = t[r];
			return n;
		}
		function i(e) {
			return e.constructor === Object || e.constructor == null;
		}
		function a(e) {
			return typeof e.then == "function";
		}
		function o(e, t) {
			return e === t || e !== e && t !== t;
		}
		var s = "[object Arguments]", c = "[object Boolean]", l = "[object Date]", u = "[object RegExp]", d = "[object Map]", f = "[object Number]", p = "[object Object]", m = "[object Set]", h = "[object String]", g = Object.prototype.toString;
		function _(e) {
			var t = e.areArraysEqual, n = e.areDatesEqual, r = e.areMapsEqual, _ = e.areObjectsEqual, v = e.areRegExpsEqual, y = e.areSetsEqual, b = e.createIsNestedEqual, x = b(S);
			function S(e, b, S) {
				if (e === b) return !0;
				if (!e || !b || typeof e != "object" || typeof b != "object") return e !== e && b !== b;
				if (i(e) && i(b)) return _(e, b, x, S);
				var C = Array.isArray(e), ee = Array.isArray(b);
				if (C || ee) return C === ee && t(e, b, x, S);
				var w = g.call(e);
				return w === g.call(b) ? w === l ? n(e, b, x, S) : w === u ? v(e, b, x, S) : w === d ? r(e, b, x, S) : w === m ? y(e, b, x, S) : w === p || w === s ? a(e) || a(b) ? !1 : _(e, b, x, S) : w === c || w === f || w === h ? o(e.valueOf(), b.valueOf()) : !1 : !1;
			}
			return S;
		}
		function v(e, t, n, r) {
			var i = e.length;
			if (t.length !== i) return !1;
			for (; i-- > 0;) if (!n(e[i], t[i], i, i, e, t, r)) return !1;
			return !0;
		}
		var y = n(v);
		function b(e, t) {
			return o(e.valueOf(), t.valueOf());
		}
		function x(e, t, n, r) {
			var i = e.size === t.size;
			if (!i) return !1;
			if (!e.size) return !0;
			var a = {}, o = 0;
			return e.forEach(function(s, c) {
				if (i) {
					var l = !1, u = 0;
					t.forEach(function(i, d) {
						!l && !a[u] && (l = n(c, d, o, u, e, t, r) && n(s, i, c, d, e, t, r)) && (a[u] = !0), u++;
					}), o++, i = l;
				}
			}), i;
		}
		var S = n(x), C = "_owner", ee = Object.prototype.hasOwnProperty;
		function w(e, t, n, r) {
			var i = Object.keys(e), a = i.length;
			if (Object.keys(t).length !== a) return !1;
			for (var o; a-- > 0;) {
				if (o = i[a], o === C) {
					var s = !!e.$$typeof, c = !!t.$$typeof;
					if ((s || c) && s !== c) return !1;
				}
				if (!ee.call(t, o) || !n(e[o], t[o], o, o, e, t, r)) return !1;
			}
			return !0;
		}
		var te = n(w);
		function T(e, t) {
			return e.source === t.source && e.flags === t.flags;
		}
		function E(e, t, n, r) {
			var i = e.size === t.size;
			if (!i) return !1;
			if (!e.size) return !0;
			var a = {};
			return e.forEach(function(o, s) {
				if (i) {
					var c = !1, l = 0;
					t.forEach(function(i, u) {
						!c && !a[l] && (c = n(o, i, s, u, e, t, r)) && (a[l] = !0), l++;
					}), i = c;
				}
			}), i;
		}
		var D = n(E), O = Object.freeze({
			areArraysEqual: v,
			areDatesEqual: b,
			areMapsEqual: x,
			areObjectsEqual: w,
			areRegExpsEqual: T,
			areSetsEqual: E,
			createIsNestedEqual: t
		}), k = Object.freeze({
			areArraysEqual: y,
			areDatesEqual: b,
			areMapsEqual: S,
			areObjectsEqual: te,
			areRegExpsEqual: T,
			areSetsEqual: D,
			createIsNestedEqual: t
		}), A = _(O);
		function j(e, t) {
			return A(e, t, void 0);
		}
		var ne = _(r(O, { createIsNestedEqual: function() {
			return o;
		} }));
		function M(e, t) {
			return ne(e, t, void 0);
		}
		var N = _(k);
		function re(e, t) {
			return N(e, t, /* @__PURE__ */ new WeakMap());
		}
		var P = _(r(k, { createIsNestedEqual: function() {
			return o;
		} }));
		function F(e, t) {
			return P(e, t, /* @__PURE__ */ new WeakMap());
		}
		function ie(e) {
			return _(r(O, e(O)));
		}
		function ae(e) {
			var t = _(r(k, e(k)));
			return (function(e, n, r) {
				return r === void 0 && (r = /* @__PURE__ */ new WeakMap()), t(e, n, r);
			});
		}
		e.circularDeepEqual = re, e.circularShallowEqual = F, e.createCustomCircularEqual = ae, e.createCustomEqual = ie, e.deepEqual = j, e.sameValueZeroEqual = o, e.shallowEqual = M, Object.defineProperty(e, "__esModule", { value: !0 });
	}));
}));
//#endregion
//#region node_modules/react-grid-layout/dist/chunk-PZLKKWSX.mjs
function Je(e = {}) {
	let { measureBeforeMount: t = !1, initialWidth: n = 1280 } = e, [r, i] = l(n), [s, u] = l(!t), d = c(null), f = c(null), p = a(() => {
		let e = d.current;
		if (e) {
			let t = e.offsetWidth;
			i(t), s || u(!0);
		}
	}, [s]);
	return o(() => {
		let e = d.current;
		if (e) {
			if (p(), typeof ResizeObserver < "u") {
				let t = null;
				return f.current = new ResizeObserver((e) => {
					let n = e[0];
					if (n) {
						let e = n.contentRect.width;
						t !== null && cancelAnimationFrame(t), t = requestAnimationFrame(() => {
							i(e), t = null;
						});
					}
				}), f.current.observe(e), () => {
					t !== null && cancelAnimationFrame(t), f.current &&= (f.current.disconnect(), null);
				};
			}
			return () => {
				f.current &&= (f.current.disconnect(), null);
			};
		}
	}, [p]), {
		width: r,
		mounted: s,
		containerRef: d,
		measureWidth: p
	};
}
//#endregion
//#region node_modules/react-is/cjs/react-is.production.min.js
var Ye = /* @__PURE__ */ t(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Xe = /* @__PURE__ */ t(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, ee = c, w = s, te = n, T = d, E = i, D = h, O = m, k = r, A = o, j = a, ne = f, M = !1;
		function N(e) {
			return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), re(e) || x(e) === l;
		}
		function re(e) {
			return x(e) === u;
		}
		function P(e) {
			return x(e) === c;
		}
		function F(e) {
			return x(e) === s;
		}
		function ie(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function ae(e) {
			return x(e) === d;
		}
		function I(e) {
			return x(e) === i;
		}
		function oe(e) {
			return x(e) === h;
		}
		function se(e) {
			return x(e) === m;
		}
		function ce(e) {
			return x(e) === r;
		}
		function le(e) {
			return x(e) === o;
		}
		function L(e) {
			return x(e) === a;
		}
		function ue(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = ee, e.ContextProvider = w, e.Element = te, e.ForwardRef = T, e.Fragment = E, e.Lazy = D, e.Memo = O, e.Portal = k, e.Profiler = A, e.StrictMode = j, e.Suspense = ne, e.isAsyncMode = N, e.isConcurrentMode = re, e.isContextConsumer = P, e.isContextProvider = F, e.isElement = ie, e.isForwardRef = ae, e.isFragment = I, e.isLazy = oe, e.isMemo = se, e.isPortal = ce, e.isProfiler = le, e.isStrictMode = L, e.isSuspense = ue, e.isValidElementType = b, e.typeOf = x;
	})();
})), Ze = /* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = Ye() : t.exports = Xe();
})), Qe = /* @__PURE__ */ t(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), $e = /* @__PURE__ */ t(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), et = /* @__PURE__ */ t(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), tt = /* @__PURE__ */ t(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = $e(), i = {}, a = et();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), nt = /* @__PURE__ */ t(((e, t) => {
	var n = Ze(), r = Qe(), i = $e(), a = et(), o = tt(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: te(),
			objectOf: ee,
			oneOf: C,
			oneOfType: w,
			shape: E,
			exact: D
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					} else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (A(s) !== e) {
					var c = j(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = A(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = A(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = A(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = M(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return j(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function ee(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = A(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function w(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ne(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function te() {
			function e(e, t, n, r, i) {
				return O(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function T(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function E(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = A(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return T(r, a, o, l, j(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function D(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = A(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return T(o, s, c, d, j(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function O(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(O);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!O(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !O(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function k(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function A(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : k(t, e) ? "symbol" : t;
		}
		function j(e) {
			if (e == null) return "" + e;
			var t = A(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function ne(e) {
			var t = j(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function M(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), rt = /* @__PURE__ */ t(((e, t) => {
	var n = $e();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), it = /* @__PURE__ */ t(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Ze();
		t.exports = nt()(n.isElement, !0);
	} else t.exports = rt()();
})), at = /* @__PURE__ */ t(((e, t) => {
	t.exports = { ...u };
})), ot = /* @__PURE__ */ t(((e, t) => {
	function n(e) {
		var t, r, i = "";
		if (typeof e == "string" || typeof e == "number") i += e;
		else if (typeof e == "object") if (Array.isArray(e)) {
			var a = e.length;
			for (t = 0; t < a; t++) e[t] && (r = n(e[t])) && (i && (i += " "), i += r);
		} else for (r in e) e[r] && (i && (i += " "), i += r);
		return i;
	}
	function r() {
		for (var e, t, r = 0, i = "", a = arguments.length; r < a; r++) (e = arguments[r]) && (t = n(e)) && (i && (i += " "), i += t);
		return i;
	}
	t.exports = r, t.exports.clsx = r;
})), st = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.dontSetMe = a, e.findInArray = t, e.int = i, e.isFunction = n, e.isNum = r;
	function t(e, t) {
		for (let n = 0, r = e.length; n < r; n++) if (t.apply(t, [
			e[n],
			n,
			e
		])) return e[n];
	}
	function n(e) {
		return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
	}
	function r(e) {
		return typeof e == "number" && !isNaN(e);
	}
	function i(e) {
		return parseInt(e, 10);
	}
	function a(e, t, n) {
		if (e[t]) return /* @__PURE__ */ Error(`Invalid prop ${t} passed to ${n} - do not set this, set it on the child.`);
	}
})), ct = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.browserPrefixToKey = r, e.browserPrefixToStyle = i, e.default = void 0, e.getPrefix = n;
	var t = [
		"Moz",
		"Webkit",
		"O",
		"ms"
	];
	function n() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
		if (typeof window > "u") return "";
		let n = window.document?.documentElement?.style;
		if (!n || e in n) return "";
		for (let i = 0; i < t.length; i++) if (r(e, t[i]) in n) return t[i];
		return "";
	}
	function r(e, t) {
		return t ? `${t}${a(e)}` : e;
	}
	function i(e, t) {
		return t ? `-${t.toLowerCase()}-${e}` : e;
	}
	function a(e) {
		let t = "", n = !0;
		for (let r = 0; r < e.length; r++) n ? (t += e[r].toUpperCase(), n = !1) : e[r] === "-" ? n = !0 : t += e[r];
		return t;
	}
	e.default = n();
})), lt = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.addClassName = S, e.addEvent = s, e.addUserSelectStyles = y, e.createCSSTransform = m, e.createSVGTransform = h, e.getTouch = _, e.getTouchIdentifier = v, e.getTranslation = g, e.innerHeight = d, e.innerWidth = f, e.matchesSelector = a, e.matchesSelectorAndParentsTo = o, e.offsetXYFromParent = p, e.outerHeight = l, e.outerWidth = u, e.removeClassName = C, e.removeEvent = c, e.scheduleRemoveUserSelectStyles = b;
	var t = st(), n = r(ct());
	function r(e, t) {
		if (typeof WeakMap == "function") var n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
		return (r = function(e, t) {
			if (!t && e && e.__esModule) return e;
			var r, a, o = {
				__proto__: null,
				default: e
			};
			if (e === null || typeof e != "object" && typeof e != "function") return o;
			if (r = t ? i : n) {
				if (r.has(e)) return r.get(e);
				r.set(e, o);
			}
			for (let t in e) t !== "default" && {}.hasOwnProperty.call(e, t) && ((a = (r = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (a.get || a.set) ? r(o, t, a) : o[t] = e[t]);
			return o;
		})(e, t);
	}
	var i = "";
	function a(e, n) {
		return i ||= (0, t.findInArray)([
			"matches",
			"webkitMatchesSelector",
			"mozMatchesSelector",
			"msMatchesSelector",
			"oMatchesSelector"
		], function(n) {
			return (0, t.isFunction)(e[n]);
		}), (0, t.isFunction)(e[i]) ? e[i](n) : !1;
	}
	function o(e, t, n) {
		let r = e;
		do {
			if (a(r, t)) return !0;
			if (r === n) return !1;
			r = r.parentNode;
		} while (r);
		return !1;
	}
	function s(e, t, n, r) {
		if (!e) return;
		let i = {
			capture: !0,
			...r
		};
		e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
	}
	function c(e, t, n, r) {
		if (!e) return;
		let i = {
			capture: !0,
			...r
		};
		e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
	}
	function l(e) {
		let n = e.clientHeight, r = e.ownerDocument.defaultView.getComputedStyle(e);
		return n += (0, t.int)(r.borderTopWidth), n += (0, t.int)(r.borderBottomWidth), n;
	}
	function u(e) {
		let n = e.clientWidth, r = e.ownerDocument.defaultView.getComputedStyle(e);
		return n += (0, t.int)(r.borderLeftWidth), n += (0, t.int)(r.borderRightWidth), n;
	}
	function d(e) {
		let n = e.clientHeight, r = e.ownerDocument.defaultView.getComputedStyle(e);
		return n -= (0, t.int)(r.paddingTop), n -= (0, t.int)(r.paddingBottom), n;
	}
	function f(e) {
		let n = e.clientWidth, r = e.ownerDocument.defaultView.getComputedStyle(e);
		return n -= (0, t.int)(r.paddingLeft), n -= (0, t.int)(r.paddingRight), n;
	}
	function p(e, t, n) {
		let r = t === t.ownerDocument.body ? {
			left: 0,
			top: 0
		} : t.getBoundingClientRect();
		return {
			x: (e.clientX + t.scrollLeft - r.left) / n,
			y: (e.clientY + t.scrollTop - r.top) / n
		};
	}
	function m(e, t) {
		let r = g(e, t, "px");
		return { [(0, n.browserPrefixToKey)("transform", n.default)]: r };
	}
	function h(e, t) {
		return g(e, t, "");
	}
	function g(e, t, n) {
		let { x: r, y: i } = e, a = `translate(${r}${n},${i}${n})`;
		return t && (a = `translate(${`${typeof t.x == "string" ? t.x : t.x + n}`}, ${`${typeof t.y == "string" ? t.y : t.y + n}`})` + a), a;
	}
	function _(e, n) {
		return e.targetTouches && (0, t.findInArray)(e.targetTouches, (e) => n === e.identifier) || e.changedTouches && (0, t.findInArray)(e.changedTouches, (e) => n === e.identifier);
	}
	function v(e) {
		if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	}
	function y(e) {
		if (!e) return;
		let t = e.getElementById("react-draggable-style-el");
		t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n", t.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n", e.getElementsByTagName("head")[0].appendChild(t)), e.body && S(e.body, "react-draggable-transparent-selection");
	}
	function b(e) {
		window.requestAnimationFrame ? window.requestAnimationFrame(() => {
			x(e);
		}) : x(e);
	}
	function x(e) {
		if (e) try {
			if (e.body && C(e.body, "react-draggable-transparent-selection"), e.selection) e.selection.empty();
			else {
				let t = (e.defaultView || window).getSelection();
				t && t.type !== "Caret" && t.removeAllRanges();
			}
		} catch {}
	}
	function S(e, t) {
		e.classList ? e.classList.add(t) : e.className.match(RegExp(`(?:^|\\s)${t}(?!\\S)`)) || (e.className += ` ${t}`);
	}
	function C(e, t) {
		e.classList ? e.classList.remove(t) : e.className = e.className.replace(RegExp(`(?:^|\\s)${t}(?!\\S)`, "g"), "");
	}
})), ut = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.canDragX = a, e.canDragY = o, e.createCoreData = c, e.createDraggableData = l, e.getBoundPosition = r, e.getControlPosition = s, e.snapToGrid = i;
	var t = st(), n = lt();
	function r(e, r, i) {
		if (!e.props.bounds) return [r, i];
		let { bounds: a } = e.props;
		a = typeof a == "string" ? a : u(a);
		let o = d(e);
		if (typeof a == "string") {
			let { ownerDocument: e } = o, r = e.defaultView, i;
			if (i = a === "parent" ? o.parentNode : o.getRootNode().querySelector(a), !(i instanceof r.HTMLElement)) throw Error("Bounds selector \"" + a + "\" could not find an element.");
			let s = i, c = r.getComputedStyle(o), l = r.getComputedStyle(s);
			a = {
				left: -o.offsetLeft + (0, t.int)(l.paddingLeft) + (0, t.int)(c.marginLeft),
				top: -o.offsetTop + (0, t.int)(l.paddingTop) + (0, t.int)(c.marginTop),
				right: (0, n.innerWidth)(s) - (0, n.outerWidth)(o) - o.offsetLeft + (0, t.int)(l.paddingRight) - (0, t.int)(c.marginRight),
				bottom: (0, n.innerHeight)(s) - (0, n.outerHeight)(o) - o.offsetTop + (0, t.int)(l.paddingBottom) - (0, t.int)(c.marginBottom)
			};
		}
		return (0, t.isNum)(a.right) && (r = Math.min(r, a.right)), (0, t.isNum)(a.bottom) && (i = Math.min(i, a.bottom)), (0, t.isNum)(a.left) && (r = Math.max(r, a.left)), (0, t.isNum)(a.top) && (i = Math.max(i, a.top)), [r, i];
	}
	function i(e, t, n) {
		return [Math.round(t / e[0]) * e[0], Math.round(n / e[1]) * e[1]];
	}
	function a(e) {
		return e.props.axis === "both" || e.props.axis === "x";
	}
	function o(e) {
		return e.props.axis === "both" || e.props.axis === "y";
	}
	function s(e, t, r) {
		let i = typeof t == "number" ? (0, n.getTouch)(e, t) : null;
		if (typeof t == "number" && !i) return null;
		let a = d(r), o = r.props.offsetParent || a.offsetParent || a.ownerDocument.body;
		return (0, n.offsetXYFromParent)(i || e, o, r.props.scale);
	}
	function c(e, n, r) {
		let i = !(0, t.isNum)(e.lastX), a = d(e);
		return i ? {
			node: a,
			deltaX: 0,
			deltaY: 0,
			lastX: n,
			lastY: r,
			x: n,
			y: r
		} : {
			node: a,
			deltaX: n - e.lastX,
			deltaY: r - e.lastY,
			lastX: e.lastX,
			lastY: e.lastY,
			x: n,
			y: r
		};
	}
	function l(e, t) {
		let n = e.props.scale;
		return {
			node: t.node,
			x: e.state.x + t.deltaX / n,
			y: e.state.y + t.deltaY / n,
			deltaX: t.deltaX / n,
			deltaY: t.deltaY / n,
			lastX: e.state.x,
			lastY: e.state.y
		};
	}
	function u(e) {
		return {
			left: e.left,
			top: e.top,
			right: e.right,
			bottom: e.bottom
		};
	}
	function d(e) {
		let t = e.findDOMNode();
		if (!t) throw Error("<DraggableCore>: Unmounted during event!");
		return t;
	}
})), dt = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
	function t() {}
})), ft = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
	var t = u(n()), r = l(it()), i = l(at()), a = lt(), o = ut(), s = st(), c = l(dt());
	function l(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function u(e, t) {
		if (typeof WeakMap == "function") var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
		return (u = function(e, t) {
			if (!t && e && e.__esModule) return e;
			var i, a, o = {
				__proto__: null,
				default: e
			};
			if (e === null || typeof e != "object" && typeof e != "function") return o;
			if (i = t ? r : n) {
				if (i.has(e)) return i.get(e);
				i.set(e, o);
			}
			for (let t in e) t !== "default" && {}.hasOwnProperty.call(e, t) && ((a = (i = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (a.get || a.set) ? i(o, t, a) : o[t] = e[t]);
			return o;
		})(e, t);
	}
	function d(e, t, n) {
		return (t = f(t)) in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function f(e) {
		var t = p(e, "string");
		return typeof t == "symbol" ? t : t + "";
	}
	function p(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	var m = {
		touch: {
			start: "touchstart",
			move: "touchmove",
			stop: "touchend"
		},
		mouse: {
			start: "mousedown",
			move: "mousemove",
			stop: "mouseup"
		}
	}, h = m.mouse, g = class extends t.Component {
		constructor() {
			super(...arguments), d(this, "dragging", !1), d(this, "lastX", NaN), d(this, "lastY", NaN), d(this, "touchIdentifier", null), d(this, "mounted", !1), d(this, "handleDragStart", (e) => {
				if (this.props.onMouseDown(e), !this.props.allowAnyClick && typeof e.button == "number" && e.button !== 0) return !1;
				let t = this.findDOMNode();
				if (!t || !t.ownerDocument || !t.ownerDocument.body) throw Error("<DraggableCore> not mounted on DragStart!");
				let { ownerDocument: n } = t;
				if (this.props.disabled || !(e.target instanceof n.defaultView.Node) || this.props.handle && !(0, a.matchesSelectorAndParentsTo)(e.target, this.props.handle, t) || this.props.cancel && (0, a.matchesSelectorAndParentsTo)(e.target, this.props.cancel, t)) return;
				e.type === "touchstart" && !this.props.allowMobileScroll && e.preventDefault();
				let r = (0, a.getTouchIdentifier)(e);
				this.touchIdentifier = r;
				let i = (0, o.getControlPosition)(e, r, this);
				if (i == null) return;
				let { x: s, y: l } = i, u = (0, o.createCoreData)(this, s, l);
				(0, c.default)("DraggableCore: handleDragStart: %j", u), (0, c.default)("calling", this.props.onStart), !(this.props.onStart(e, u) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, a.addUserSelectStyles)(n), this.dragging = !0, this.lastX = s, this.lastY = l, (0, a.addEvent)(n, h.move, this.handleDrag), (0, a.addEvent)(n, h.stop, this.handleDragStop));
			}), d(this, "handleDrag", (e) => {
				let t = (0, o.getControlPosition)(e, this.touchIdentifier, this);
				if (t == null) return;
				let { x: n, y: r } = t;
				if (Array.isArray(this.props.grid)) {
					let e = n - this.lastX, t = r - this.lastY;
					if ([e, t] = (0, o.snapToGrid)(this.props.grid, e, t), !e && !t) return;
					n = this.lastX + e, r = this.lastY + t;
				}
				let i = (0, o.createCoreData)(this, n, r);
				if ((0, c.default)("DraggableCore: handleDrag: %j", i), this.props.onDrag(e, i) === !1 || this.mounted === !1) {
					try {
						this.handleDragStop(new MouseEvent("mouseup"));
					} catch {
						let e = document.createEvent("MouseEvents");
						e.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(e);
					}
					return;
				}
				this.lastX = n, this.lastY = r;
			}), d(this, "handleDragStop", (e) => {
				if (!this.dragging) return;
				let t = (0, o.getControlPosition)(e, this.touchIdentifier, this);
				if (t == null) return;
				let { x: n, y: r } = t;
				if (Array.isArray(this.props.grid)) {
					let e = n - this.lastX || 0, t = r - this.lastY || 0;
					[e, t] = (0, o.snapToGrid)(this.props.grid, e, t), n = this.lastX + e, r = this.lastY + t;
				}
				let i = (0, o.createCoreData)(this, n, r);
				if (this.props.onStop(e, i) === !1 || this.mounted === !1) return !1;
				let s = this.findDOMNode();
				s && this.props.enableUserSelectHack && (0, a.scheduleRemoveUserSelectStyles)(s.ownerDocument), (0, c.default)("DraggableCore: handleDragStop: %j", i), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, s && ((0, c.default)("DraggableCore: Removing handlers"), (0, a.removeEvent)(s.ownerDocument, h.move, this.handleDrag), (0, a.removeEvent)(s.ownerDocument, h.stop, this.handleDragStop));
			}), d(this, "onMouseDown", (e) => (h = m.mouse, this.handleDragStart(e))), d(this, "onMouseUp", (e) => (h = m.mouse, this.handleDragStop(e))), d(this, "onTouchStart", (e) => (h = m.touch, this.handleDragStart(e))), d(this, "onTouchEnd", (e) => (h = m.touch, this.handleDragStop(e)));
		}
		componentDidMount() {
			this.mounted = !0;
			let e = this.findDOMNode();
			e && (0, a.addEvent)(e, m.touch.start, this.onTouchStart, { passive: !1 });
		}
		componentWillUnmount() {
			this.mounted = !1;
			let e = this.findDOMNode();
			if (e) {
				let { ownerDocument: t } = e;
				(0, a.removeEvent)(t, m.mouse.move, this.handleDrag), (0, a.removeEvent)(t, m.touch.move, this.handleDrag), (0, a.removeEvent)(t, m.mouse.stop, this.handleDragStop), (0, a.removeEvent)(t, m.touch.stop, this.handleDragStop), (0, a.removeEvent)(e, m.touch.start, this.onTouchStart, { passive: !1 }), this.props.enableUserSelectHack && (0, a.scheduleRemoveUserSelectStyles)(t);
			}
		}
		findDOMNode() {
			return this.props?.nodeRef ? this.props?.nodeRef?.current : i.default.findDOMNode(this);
		}
		render() {
			return /*#__PURE__*/ t.cloneElement(t.Children.only(this.props.children), {
				onMouseDown: this.onMouseDown,
				onMouseUp: this.onMouseUp,
				onTouchEnd: this.onTouchEnd
			});
		}
	};
	e.default = g, d(g, "displayName", "DraggableCore"), d(g, "propTypes", {
		allowAnyClick: r.default.bool,
		allowMobileScroll: r.default.bool,
		children: r.default.node.isRequired,
		disabled: r.default.bool,
		enableUserSelectHack: r.default.bool,
		offsetParent: function(e, t) {
			if (e[t] && e[t].nodeType !== 1) throw Error("Draggable's offsetParent must be a DOM Node.");
		},
		grid: r.default.arrayOf(r.default.number),
		handle: r.default.string,
		cancel: r.default.string,
		nodeRef: r.default.object,
		onStart: r.default.func,
		onDrag: r.default.func,
		onStop: r.default.func,
		onMouseDown: r.default.func,
		scale: r.default.number,
		className: s.dontSetMe,
		style: s.dontSetMe,
		transform: s.dontSetMe
	}), d(g, "defaultProps", {
		allowAnyClick: !1,
		allowMobileScroll: !1,
		disabled: !1,
		enableUserSelectHack: !0,
		onStart: function() {},
		onDrag: function() {},
		onStop: function() {},
		onMouseDown: function() {},
		scale: 1
	});
})), pt = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), Object.defineProperty(e, "DraggableCore", {
		enumerable: !0,
		get: function() {
			return l.default;
		}
	}), e.default = void 0;
	var t = f(n()), r = d(it()), i = d(at()), a = ot(), o = lt(), s = ut(), c = st(), l = d(ft()), u = d(dt());
	function d(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function f(e, t) {
		if (typeof WeakMap == "function") var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
		return (f = function(e, t) {
			if (!t && e && e.__esModule) return e;
			var i, a, o = {
				__proto__: null,
				default: e
			};
			if (e === null || typeof e != "object" && typeof e != "function") return o;
			if (i = t ? r : n) {
				if (i.has(e)) return i.get(e);
				i.set(e, o);
			}
			for (let t in e) t !== "default" && {}.hasOwnProperty.call(e, t) && ((a = (i = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (a.get || a.set) ? i(o, t, a) : o[t] = e[t]);
			return o;
		})(e, t);
	}
	function p() {
		return p = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, p.apply(null, arguments);
	}
	function m(e, t, n) {
		return (t = h(t)) in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function h(e) {
		var t = g(e, "string");
		return typeof t == "symbol" ? t : t + "";
	}
	function g(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	var _ = class extends t.Component {
		static getDerivedStateFromProps(e, t) {
			let { position: n } = e, { prevPropsPosition: r } = t;
			return n && (!r || n.x !== r.x || n.y !== r.y) ? ((0, u.default)("Draggable: getDerivedStateFromProps %j", {
				position: n,
				prevPropsPosition: r
			}), {
				x: n.x,
				y: n.y,
				prevPropsPosition: { ...n }
			}) : null;
		}
		constructor(e) {
			super(e), m(this, "onDragStart", (e, t) => {
				if ((0, u.default)("Draggable: onDragStart: %j", t), this.props.onStart(e, (0, s.createDraggableData)(this, t)) === !1) return !1;
				this.setState({
					dragging: !0,
					dragged: !0
				});
			}), m(this, "onDrag", (e, t) => {
				if (!this.state.dragging) return !1;
				(0, u.default)("Draggable: onDrag: %j", t);
				let n = (0, s.createDraggableData)(this, t), r = {
					x: n.x,
					y: n.y,
					slackX: 0,
					slackY: 0
				};
				if (this.props.bounds) {
					let { x: e, y: t } = r;
					r.x += this.state.slackX, r.y += this.state.slackY;
					let [i, a] = (0, s.getBoundPosition)(this, r.x, r.y);
					r.x = i, r.y = a, r.slackX = this.state.slackX + (e - r.x), r.slackY = this.state.slackY + (t - r.y), n.x = r.x, n.y = r.y, n.deltaX = r.x - this.state.x, n.deltaY = r.y - this.state.y;
				}
				if (this.props.onDrag(e, n) === !1) return !1;
				this.setState(r);
			}), m(this, "onDragStop", (e, t) => {
				if (!this.state.dragging || this.props.onStop(e, (0, s.createDraggableData)(this, t)) === !1) return !1;
				(0, u.default)("Draggable: onDragStop: %j", t);
				let n = {
					dragging: !1,
					slackX: 0,
					slackY: 0
				};
				if (this.props.position) {
					let { x: e, y: t } = this.props.position;
					n.x = e, n.y = t;
				}
				this.setState(n);
			}), this.state = {
				dragging: !1,
				dragged: !1,
				x: e.position ? e.position.x : e.defaultPosition.x,
				y: e.position ? e.position.y : e.defaultPosition.y,
				prevPropsPosition: { ...e.position },
				slackX: 0,
				slackY: 0,
				isElementSVG: !1
			}, e.position && !(e.onDrag || e.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
		}
		componentDidMount() {
			window.SVGElement !== void 0 && this.findDOMNode() instanceof window.SVGElement && this.setState({ isElementSVG: !0 });
		}
		componentWillUnmount() {
			this.state.dragging && this.setState({ dragging: !1 });
		}
		findDOMNode() {
			return this.props?.nodeRef?.current ?? i.default.findDOMNode(this);
		}
		render() {
			let { axis: e, bounds: n, children: r, defaultPosition: i, defaultClassName: c, defaultClassNameDragging: u, defaultClassNameDragged: d, position: f, positionOffset: m, scale: h, ...g } = this.props, _ = {}, v = null, y = !f || this.state.dragging, b = f || i, x = {
				x: (0, s.canDragX)(this) && y ? this.state.x : b.x,
				y: (0, s.canDragY)(this) && y ? this.state.y : b.y
			};
			this.state.isElementSVG ? v = (0, o.createSVGTransform)(x, m) : _ = (0, o.createCSSTransform)(x, m);
			let S = (0, a.clsx)(r.props.className || "", c, {
				[u]: this.state.dragging,
				[d]: this.state.dragged
			});
			return /*#__PURE__*/ t.createElement(l.default, p({}, g, {
				onStart: this.onDragStart,
				onDrag: this.onDrag,
				onStop: this.onDragStop
			}), /*#__PURE__*/ t.cloneElement(t.Children.only(r), {
				className: S,
				style: {
					...r.props.style,
					..._
				},
				transform: v
			}));
		}
	};
	e.default = _, m(_, "displayName", "Draggable"), m(_, "propTypes", {
		...l.default.propTypes,
		axis: r.default.oneOf([
			"both",
			"x",
			"y",
			"none"
		]),
		bounds: r.default.oneOfType([
			r.default.shape({
				left: r.default.number,
				right: r.default.number,
				top: r.default.number,
				bottom: r.default.number
			}),
			r.default.string,
			r.default.oneOf([!1])
		]),
		defaultClassName: r.default.string,
		defaultClassNameDragging: r.default.string,
		defaultClassNameDragged: r.default.string,
		defaultPosition: r.default.shape({
			x: r.default.number,
			y: r.default.number
		}),
		positionOffset: r.default.shape({
			x: r.default.oneOfType([r.default.number, r.default.string]),
			y: r.default.oneOfType([r.default.number, r.default.string])
		}),
		position: r.default.shape({
			x: r.default.number,
			y: r.default.number
		}),
		className: c.dontSetMe,
		style: c.dontSetMe,
		transform: c.dontSetMe
	}), m(_, "defaultProps", {
		...l.default.defaultProps,
		axis: "both",
		bounds: !1,
		defaultClassName: "react-draggable",
		defaultClassNameDragging: "react-draggable-dragging",
		defaultClassNameDragged: "react-draggable-dragged",
		defaultPosition: {
			x: 0,
			y: 0
		},
		scale: 1
	});
})), mt = /* @__PURE__ */ t(((e, t) => {
	var { default: n, DraggableCore: r } = pt();
	t.exports = n, t.exports.default = n, t.exports.DraggableCore = r;
})), ht = /* @__PURE__ */ t(((e) => {
	e.__esModule = !0, e.cloneElement = l;
	var t = r(n());
	function r(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function i(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function a(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t] == null ? {} : arguments[t];
			t % 2 ? i(Object(n), !0).forEach(function(t) {
				o(e, t, n[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
			});
		}
		return e;
	}
	function o(e, t, n) {
		return (t = s(t)) in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function s(e) {
		var t = c(e, "string");
		return typeof t == "symbol" ? t : t + "";
	}
	function c(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	function l(e, n) {
		return n.style && e.props.style && (n.style = a(a({}, e.props.style), n.style)), n.className && e.props.className && (n.className = `${e.props.className} ${n.className}`), /*#__PURE__*/ t.default.cloneElement(e, n);
	}
})), gt = /* @__PURE__ */ t(((e) => {
	e.__esModule = !0, e.resizableProps = void 0;
	var t = n(it());
	mt();
	function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	e.resizableProps = {
		axis: t.default.oneOf([
			"both",
			"x",
			"y",
			"none"
		]),
		className: t.default.string,
		children: t.default.element.isRequired,
		draggableOpts: t.default.shape({
			allowAnyClick: t.default.bool,
			cancel: t.default.string,
			children: t.default.node,
			disabled: t.default.bool,
			enableUserSelectHack: t.default.bool,
			offsetParent: typeof Element < "u" ? t.default.instanceOf(Element) : t.default.any,
			grid: t.default.arrayOf(t.default.number),
			handle: t.default.string,
			nodeRef: t.default.object,
			onStart: t.default.func,
			onDrag: t.default.func,
			onStop: t.default.func,
			onMouseDown: t.default.func,
			scale: t.default.number
		}),
		height: function() {
			var e = [...arguments];
			let [n] = e;
			return n.axis === "both" || n.axis === "y" ? t.default.number.isRequired(...e) : t.default.number(...e);
		},
		handle: t.default.oneOfType([t.default.node, t.default.func]),
		handleSize: t.default.arrayOf(t.default.number),
		lockAspectRatio: t.default.bool,
		maxConstraints: t.default.arrayOf(t.default.number),
		minConstraints: t.default.arrayOf(t.default.number),
		onResizeStop: t.default.func,
		onResizeStart: t.default.func,
		onResize: t.default.func,
		resizeHandles: t.default.arrayOf(t.default.oneOf([
			"s",
			"w",
			"e",
			"n",
			"sw",
			"nw",
			"se",
			"ne"
		])),
		transformScale: t.default.number,
		width: function() {
			var e = [...arguments];
			let [n] = e;
			return n.axis === "both" || n.axis === "x" ? t.default.number.isRequired(...e) : t.default.number(...e);
		}
	};
})), _t = /* @__PURE__ */ t(((e) => {
	e.__esModule = !0, e.default = void 0;
	var t = s(n()), r = mt(), i = ht(), a = gt(), o = [
		"children",
		"className",
		"draggableOpts",
		"width",
		"height",
		"handle",
		"handleSize",
		"lockAspectRatio",
		"axis",
		"minConstraints",
		"maxConstraints",
		"onResize",
		"onResizeStop",
		"onResizeStart",
		"resizeHandles",
		"transformScale"
	];
	function s(e, t) {
		if (typeof WeakMap == "function") var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
		return (s = function(e, t) {
			if (!t && e && e.__esModule) return e;
			var i, a, o = {
				__proto__: null,
				default: e
			};
			if (e === null || typeof e != "object" && typeof e != "function") return o;
			if (i = t ? r : n) {
				if (i.has(e)) return i.get(e);
				i.set(e, o);
			}
			for (let t in e) t !== "default" && {}.hasOwnProperty.call(e, t) && ((a = (i = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (a.get || a.set) ? i(o, t, a) : o[t] = e[t]);
			return o;
		})(e, t);
	}
	function c() {
		return c = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, c.apply(null, arguments);
	}
	function l(e, t) {
		if (e == null) return {};
		var n, r, i = u(e, t);
		if (Object.getOwnPropertySymbols) {
			var a = Object.getOwnPropertySymbols(e);
			for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
		}
		return i;
	}
	function u(e, t) {
		if (e == null) return {};
		var n = {};
		for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
			if (t.indexOf(r) !== -1) continue;
			n[r] = e[r];
		}
		return n;
	}
	function d(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function f(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t] == null ? {} : arguments[t];
			t % 2 ? d(Object(n), !0).forEach(function(t) {
				p(e, t, n[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
			});
		}
		return e;
	}
	function p(e, t, n) {
		return (t = m(t)) in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function m(e) {
		var t = h(e, "string");
		return typeof t == "symbol" ? t : t + "";
	}
	function h(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	var g = class extends t.Component {
		constructor() {
			super(...arguments), this.handleRefs = {}, this.lastHandleRect = null, this.slack = null, this.lastSize = null;
		}
		componentWillUnmount() {
			this.resetData();
		}
		resetData() {
			this.lastHandleRect = this.slack = this.lastSize = null;
		}
		runConstraints(e, t) {
			let { minConstraints: n, maxConstraints: r, lockAspectRatio: i } = this.props;
			if (!n && !r && !i) return [e, t];
			if (i) {
				let n = this.props.width / this.props.height, r = e - this.props.width, i = t - this.props.height;
				Math.abs(r) > Math.abs(i * n) ? t = e / n : e = t * n;
			}
			let [a, o] = [e, t], [s, c] = this.slack || [0, 0];
			return e += s, t += c, n && (e = Math.max(n[0], e), t = Math.max(n[1], t)), r && (e = Math.min(r[0], e), t = Math.min(r[1], t)), this.slack = [s + (a - e), c + (o - t)], [e, t];
		}
		resizeHandler(e, t) {
			return (n, r) => {
				let { node: i, deltaX: a, deltaY: o } = r;
				e === "onResizeStart" && this.resetData();
				let s = (this.props.axis === "both" || this.props.axis === "x") && t !== "n" && t !== "s", c = (this.props.axis === "both" || this.props.axis === "y") && t !== "e" && t !== "w";
				if (!s && !c) return;
				let l = t[0], u = t[t.length - 1], d = i.getBoundingClientRect();
				if (this.lastHandleRect != null) {
					if (u === "w") {
						let e = d.left - this.lastHandleRect.left;
						a += e;
					}
					if (l === "n") {
						let e = d.top - this.lastHandleRect.top;
						o += e;
					}
				}
				this.lastHandleRect = d, u === "w" && (a = -a), l === "n" && (o = -o);
				let f = this.props.width + (s ? a / this.props.transformScale : 0), p = this.props.height + (c ? o / this.props.transformScale : 0);
				[f, p] = this.runConstraints(f, p), e === "onResizeStop" && this.lastSize && ({width: f, height: p} = this.lastSize);
				let m = f !== this.props.width || p !== this.props.height;
				e !== "onResizeStop" && (this.lastSize = {
					width: f,
					height: p
				});
				let h = typeof this.props[e] == "function" ? this.props[e] : null;
				h && !(e === "onResize" && !m) && (n.persist?.(), h(n, {
					node: i,
					size: {
						width: f,
						height: p
					},
					handle: t
				})), e === "onResizeStop" && this.resetData();
			};
		}
		renderResizeHandle(e, n) {
			let { handle: r } = this.props;
			if (!r) return /*#__PURE__*/ t.createElement("span", {
				className: `react-resizable-handle react-resizable-handle-${e}`,
				ref: n
			});
			if (typeof r == "function") return r(e, n);
			let i = typeof r.type == "string", a = f({ ref: n }, i ? {} : { handleAxis: e });
			return /*#__PURE__*/ t.cloneElement(r, a);
		}
		render() {
			let e = this.props, { children: n, className: a, draggableOpts: s, width: u, height: d, handle: p, handleSize: m, lockAspectRatio: h, axis: g, minConstraints: _, maxConstraints: v, onResize: y, onResizeStop: b, onResizeStart: x, resizeHandles: S, transformScale: C } = e, ee = l(e, o);
			return (0, i.cloneElement)(n, f(f({}, ee), {}, {
				className: `${a ? `${a} ` : ""}react-resizable`,
				children: [...t.Children.toArray(n.props.children), ...S.map((e) => {
					let n = this.handleRefs[e] ?? (this.handleRefs[e] = /*#__PURE__*/ t.createRef());
					return /*#__PURE__*/ t.createElement(r.DraggableCore, c({}, s, {
						nodeRef: n,
						key: `resizableHandle-${e}`,
						onStop: this.resizeHandler("onResizeStop", e),
						onStart: this.resizeHandler("onResizeStart", e),
						onDrag: this.resizeHandler("onResize", e)
					}), this.renderResizeHandle(e, n));
				})]
			}));
		}
	};
	e.default = g, g.propTypes = a.resizableProps, g.defaultProps = {
		axis: "both",
		handleSize: [20, 20],
		lockAspectRatio: !1,
		minConstraints: [20, 20],
		maxConstraints: [Infinity, Infinity],
		resizeHandles: ["se"],
		transformScale: 1
	};
})), vt = /* @__PURE__ */ t(((e) => {
	e.__esModule = !0, e.default = void 0;
	var t = c(n()), r = s(it()), i = s(_t()), a = gt(), o = [
		"handle",
		"handleSize",
		"onResize",
		"onResizeStart",
		"onResizeStop",
		"draggableOpts",
		"minConstraints",
		"maxConstraints",
		"lockAspectRatio",
		"axis",
		"width",
		"height",
		"resizeHandles",
		"style",
		"transformScale"
	];
	function s(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function c(e, t) {
		if (typeof WeakMap == "function") var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
		return (c = function(e, t) {
			if (!t && e && e.__esModule) return e;
			var i, a, o = {
				__proto__: null,
				default: e
			};
			if (e === null || typeof e != "object" && typeof e != "function") return o;
			if (i = t ? r : n) {
				if (i.has(e)) return i.get(e);
				i.set(e, o);
			}
			for (let t in e) t !== "default" && {}.hasOwnProperty.call(e, t) && ((a = (i = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (a.get || a.set) ? i(o, t, a) : o[t] = e[t]);
			return o;
		})(e, t);
	}
	function l() {
		return l = Object.assign ? Object.assign.bind() : function(e) {
			for (var t = 1; t < arguments.length; t++) {
				var n = arguments[t];
				for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
			}
			return e;
		}, l.apply(null, arguments);
	}
	function u(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function d(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t] == null ? {} : arguments[t];
			t % 2 ? u(Object(n), !0).forEach(function(t) {
				f(e, t, n[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
			});
		}
		return e;
	}
	function f(e, t, n) {
		return (t = p(t)) in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function p(e) {
		var t = m(e, "string");
		return typeof t == "symbol" ? t : t + "";
	}
	function m(e, t) {
		if (typeof e != "object" || !e) return e;
		var n = e[Symbol.toPrimitive];
		if (n !== void 0) {
			var r = n.call(e, t || "default");
			if (typeof r != "object") return r;
			throw TypeError("@@toPrimitive must return a primitive value.");
		}
		return (t === "string" ? String : Number)(e);
	}
	function h(e, t) {
		if (e == null) return {};
		var n, r, i = g(e, t);
		if (Object.getOwnPropertySymbols) {
			var a = Object.getOwnPropertySymbols(e);
			for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
		}
		return i;
	}
	function g(e, t) {
		if (e == null) return {};
		var n = {};
		for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
			if (t.indexOf(r) !== -1) continue;
			n[r] = e[r];
		}
		return n;
	}
	var _ = class extends t.Component {
		constructor() {
			super(...arguments), this.state = {
				width: this.props.width,
				height: this.props.height,
				propsWidth: this.props.width,
				propsHeight: this.props.height
			}, this.onResize = (e, t) => {
				let { size: n } = t;
				this.props.onResize ? (e.persist?.(), this.setState(n, () => this.props.onResize && this.props.onResize(e, t))) : this.setState(n);
			};
		}
		static getDerivedStateFromProps(e, t) {
			return t.propsWidth !== e.width || t.propsHeight !== e.height ? {
				width: e.width,
				height: e.height,
				propsWidth: e.width,
				propsHeight: e.height
			} : null;
		}
		render() {
			let e = this.props, { handle: n, handleSize: r, onResize: a, onResizeStart: s, onResizeStop: c, draggableOpts: u, minConstraints: f, maxConstraints: p, lockAspectRatio: m, axis: g, width: _, height: v, resizeHandles: y, style: b, transformScale: x } = e, S = h(e, o);
			return /*#__PURE__*/ t.createElement(i.default, {
				axis: g,
				draggableOpts: u,
				handle: n,
				handleSize: r,
				height: this.state.height,
				lockAspectRatio: m,
				maxConstraints: p,
				minConstraints: f,
				onResizeStart: s,
				onResize: this.onResize,
				onResizeStop: c,
				resizeHandles: y,
				transformScale: x,
				width: this.state.width
			}, /*#__PURE__*/ t.createElement("div", l({}, S, { style: d(d({}, b), {}, {
				width: this.state.width + "px",
				height: this.state.height + "px"
			}) })));
		}
	};
	e.default = _, _.propTypes = d(d({}, a.resizableProps), {}, { children: r.default.element });
})), yt = /* @__PURE__ */ t(((e, t) => {
	t.exports = function() {
		throw Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	}, t.exports.Resizable = _t().default, t.exports.ResizableBox = vt().default;
})), bt = mt(), xt = yt();
function St(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = St(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function Ct() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = St(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/react-grid-layout/dist/chunk-WGL5FSZH.mjs
var wt = r(), Tt = qe();
function Et(e) {
	let { children: t, cols: n, containerWidth: r, margin: u, containerPadding: d, rowHeight: f, maxRows: p, isDraggable: m, isResizable: h, isBounded: g, static: _, useCSSTransforms: v = !0, usePercentages: y = !1, transformScale: b = 1, positionStrategy: x, dragThreshold: S = 0, droppingPosition: C, className: ee = "", style: w, handle: te = "", cancel: T = "", x: E, y: D, w: O, h: k, minW: A = 1, maxW: j = Infinity, minH: ne = 1, maxH: M = Infinity, i: N, resizeHandles: re, resizeHandle: P, constraints: F = Ce, layoutItem: ie, layout: ae = [], onDragStart: I, onDrag: oe, onDragStop: se, onResizeStart: ce, onResize: de, onResizeStop: he } = e, [R, ge] = l(!1), [z, B] = l(!1), V = c(null), H = c({
		left: 0,
		top: 0
	}), _e = c({
		top: 0,
		left: 0,
		width: 0,
		height: 0
	}), U = c(void 0), ve = c(ae);
	ve.current = ae;
	let ye = c(null), be = c(null), xe = c(!1), W = c({
		x: 0,
		y: 0
	}), G = c(!1), K = s(() => ({
		cols: n,
		containerPadding: d,
		containerWidth: r,
		margin: u,
		maxRows: p,
		rowHeight: f
	}), [
		n,
		d,
		r,
		u,
		p,
		f
	]), Se = s(() => ({
		cols: n,
		maxRows: p,
		containerWidth: r,
		containerHeight: 0,
		rowHeight: f,
		margin: u,
		layout: []
	}), [
		n,
		p,
		r,
		f,
		u
	]), Y = a(() => ({
		...Se,
		layout: ve.current
	}), [Se]), X = s(() => ie ?? {
		i: N,
		x: E,
		y: D,
		w: O,
		h: k,
		minW: A,
		maxW: j,
		minH: ne,
		maxH: M
	}, [
		ie,
		N,
		E,
		D,
		O,
		k,
		A,
		j,
		ne,
		M
	]), De = a((e) => {
		if (x?.calcStyle) return x.calcStyle(e);
		if (v) return J(e);
		let t = Te(e);
		return y ? {
			...t,
			left: Ee(e.left / r),
			width: Ee(e.width / r)
		} : t;
	}, [
		x,
		v,
		y,
		r
	]), Z = a((e, { node: t }) => {
		if (!I) return;
		let { offsetParent: n } = t;
		if (!n) return;
		let r = n.getBoundingClientRect(), i = t.getBoundingClientRect(), a = i.left / b, o = r.left / b, s = i.top / b, c = r.top / b, l;
		if (x?.calcDragPosition) {
			let t = e;
			l = x.calcDragPosition(t.clientX, t.clientY, t.clientX - i.left, t.clientY - i.top);
		} else l = {
			left: a - o + n.scrollLeft,
			top: s - c + n.scrollTop
		};
		if (H.current = l, S > 0) {
			let t = e;
			W.current = {
				x: t.clientX,
				y: t.clientY
			}, xe.current = !0, G.current = !1, ge(!0);
			return;
		}
		ge(!0);
		let u = fe(K, l.top, l.left), { x: d, y: f } = q(F, X, u.x, u.y, Y());
		I(N, d, f, {
			e,
			node: t,
			newPosition: l
		});
	}, [
		I,
		b,
		K,
		x,
		S,
		F,
		X,
		Y,
		N
	]), Oe = a((e, { node: t, deltaX: n, deltaY: i }) => {
		if (!oe || !R) return;
		let a = e;
		if (xe.current && !G.current) {
			let n = a.clientX - W.current.x, r = a.clientY - W.current.y;
			if (Math.hypot(n, r) < S) return;
			if (G.current = !0, xe.current = !1, I) {
				let n = fe(K, H.current.top, H.current.left), { x: r, y: i } = q(F, X, n.x, n.y, Y());
				I(N, r, i, {
					e,
					node: t,
					newPosition: H.current
				});
			}
		}
		let o = H.current.top + i, s = H.current.left + n;
		if (g) {
			let { offsetParent: e } = t;
			if (e) {
				let t = e.clientHeight - L(k, f, u[1]);
				o = me(o, 0, t);
				let n = r - L(O, le(K), u[0]);
				s = me(s, 0, n);
			}
		}
		let c = {
			top: o,
			left: s
		};
		H.current = c;
		let l = fe(K, o, s), { x: d, y: p } = q(F, X, l.x, l.y, Y());
		oe(N, d, p, {
			e,
			node: t,
			newPosition: c
		});
	}, [
		oe,
		I,
		R,
		S,
		g,
		k,
		f,
		u,
		K,
		r,
		O,
		N,
		F,
		X,
		Y
	]), ke = a((e, { node: t }) => {
		if (!se || !R) return;
		let n = xe.current;
		if (xe.current = !1, G.current = !1, W.current = {
			x: 0,
			y: 0
		}, n) {
			ge(!1), H.current = {
				left: 0,
				top: 0
			};
			return;
		}
		let { left: r, top: i } = H.current, a = {
			top: i,
			left: r
		};
		ge(!1), H.current = {
			left: 0,
			top: 0
		};
		let o = fe(K, i, r), { x: s, y: c } = q(F, X, o.x, o.y, Y());
		se(N, s, c, {
			e,
			node: t,
			newPosition: a
		});
	}, [
		se,
		R,
		K,
		F,
		X,
		Y,
		N
	]);
	ye.current = Z, be.current = Oe;
	let Q = a((e, { node: t, size: n, handle: i }, a, o) => {
		let s = o === "onResizeStart" ? ce : o === "onResize" ? de : he;
		if (!s) return;
		let c;
		c = t ? Me(i, a, n, r) : {
			...n,
			top: a.top,
			left: a.left
		}, _e.current = c;
		let l = pe(K, c.width, c.height), { w: u, h: d } = we(F, X, l.w, l.h, i, Y());
		s(N, u, d, {
			e: e.nativeEvent,
			node: t,
			size: c,
			handle: i
		});
	}, [
		ce,
		de,
		he,
		r,
		K,
		N,
		F,
		X,
		Y
	]), Ae = a((e, t) => {
		B(!0);
		let n = ue(K, E, D, O, k);
		Q(e, {
			...t,
			handle: t.handle
		}, n, "onResizeStart");
	}, [
		Q,
		K,
		E,
		D,
		O,
		k
	]), je = a((e, t) => {
		let n = ue(K, E, D, O, k);
		Q(e, {
			...t,
			handle: t.handle
		}, n, "onResize");
	}, [
		Q,
		K,
		E,
		D,
		O,
		k
	]), Ne = a((e, t) => {
		B(!1), _e.current = {
			top: 0,
			left: 0,
			width: 0,
			height: 0
		};
		let n = ue(K, E, D, O, k);
		Q(e, {
			...t,
			handle: t.handle
		}, n, "onResizeStop");
	}, [
		Q,
		K,
		E,
		D,
		O,
		k
	]);
	o(() => {
		if (!C) return;
		let e = V.current;
		if (!e) return;
		let t = U.current || {
			left: 0,
			top: 0
		}, n = R && (C.left !== t.left || C.top !== t.top);
		if (!R) {
			let t = {
				node: e,
				deltaX: C.left,
				deltaY: C.top,
				lastX: 0,
				lastY: 0,
				x: C.left,
				y: C.top
			};
			ye.current?.(C.e, t);
		} else if (n) {
			let t = {
				node: e,
				deltaX: C.left - H.current.left,
				deltaY: C.top - H.current.top,
				lastX: H.current.left,
				lastY: H.current.top,
				x: C.left,
				y: C.top
			};
			be.current?.(C.e, t);
		}
		U.current = C;
	}, [
		C,
		R,
		N
	]);
	let Pe = ue(K, E, D, O, k, R ? H.current : null, z ? _e.current : null), Fe = i.Children.only(t), Ie = le(K), Le = [L(A, Ie, u[0]), L(ne, f, u[1])], Re = [L(j, Ie, u[0]), L(M, f, u[1])], ze = Fe.props, Be = ze.className, $ = ze.style, Ve = i.cloneElement(Fe, {
		ref: V,
		className: Ct("react-grid-item", Be, ee, {
			static: _,
			resizing: z,
			"react-draggable": m,
			"react-draggable-dragging": R,
			dropping: !!C,
			cssTransforms: v
		}),
		style: {
			...w,
			...$,
			...De(Pe)
		}
	}), He = P;
	return Ve = /* @__PURE__ */ (0, wt.jsx)(xt.Resizable, {
		draggableOpts: { disabled: !h },
		className: h ? void 0 : "react-resizable-hide",
		width: Pe.width,
		height: Pe.height,
		minConstraints: Le,
		maxConstraints: Re,
		onResizeStart: Ae,
		onResize: je,
		onResizeStop: Ne,
		transformScale: b,
		resizeHandles: re,
		handle: He,
		children: Ve
	}), Ve = /* @__PURE__ */ (0, wt.jsx)(bt.DraggableCore, {
		disabled: !m,
		onStart: Z,
		onDrag: Oe,
		onStop: ke,
		handle: te,
		cancel: ".react-resizable-handle" + (T ? "," + T : ""),
		scale: b,
		nodeRef: V,
		children: Ve
	}), Ve;
}
var Dt = () => {}, Ot = "react-grid-layout", kt = !1;
try {
	kt = /firefox/i.test(navigator.userAgent);
} catch {}
function At(e, t) {
	let n = i.Children.toArray(e), r = i.Children.toArray(t);
	if (n.length !== r.length) return !1;
	for (let e = 0; e < n.length; e++) {
		let t = n[e], i = r[e];
		if (t?.key !== i?.key) return !1;
	}
	return !0;
}
function jt(e, t, n, r) {
	let a = [], o = /* @__PURE__ */ new Set();
	i.Children.forEach(t, (t) => {
		if (!i.isValidElement(t) || t.key === null) return;
		let n = String(t.key);
		o.add(n);
		let r = e.find((e) => e.i === n);
		if (r) a.push(ve(r));
		else {
			let e = t.props["data-grid"];
			e ? a.push({
				i: n,
				x: e.x ?? 0,
				y: e.y ?? 0,
				w: e.w ?? 1,
				h: e.h ?? 1,
				minW: e.minW,
				maxW: e.maxW,
				minH: e.minH,
				maxH: e.maxH,
				static: e.static,
				isDraggable: e.isDraggable,
				isResizable: e.isResizable,
				resizeHandles: e.resizeHandles,
				isBounded: e.isBounded
			}) : a.push({
				i: n,
				x: 0,
				y: H(a),
				w: 1,
				h: 1
			});
		}
	});
	let s = W(a, { cols: n });
	return r.compact(s, n);
}
function Mt(e) {
	let { children: t, width: n, gridConfig: r, dragConfig: u, resizeConfig: d, dropConfig: f, positionStrategy: p = Ne, compactor: m, constraints: h = Ce, layout: g = [], droppingItem: _, autoSize: v = !0, className: y = "", style: b = {}, innerRef: x, onLayoutChange: S = Dt, onDragStart: C = Dt, onDrag: ee = Dt, onDragStop: w = Dt, onResizeStart: te = Dt, onResize: T = Dt, onResizeStop: E = Dt, onDrop: D = Dt, onDropDragOver: O = Dt } = e, k = s(() => ({
		...Pe,
		...r
	}), [r]), A = s(() => ({
		...Fe,
		...u
	}), [u]), j = s(() => ({
		...Ie,
		...d
	}), [d]), ne = s(() => ({
		...Le,
		...f
	}), [f]), { cols: M, rowHeight: N, maxRows: re, margin: P, containerPadding: F } = k, { enabled: ie, bounded: ae, handle: I, cancel: oe, threshold: se } = A, { enabled: ce, handles: ue, handleComponent: fe } = j, { enabled: pe, defaultItem: me, onDragOver: he } = ne, R = m ?? Ke("vertical"), z = R.type, B = R.allowOverlap, V = R.preventCollision ?? !1, U = s(() => _ ?? {
		i: "__dropping-elem__",
		...me
	}, [_, me]), ye = p.type === "transform", be = p.scale, W = F ?? P, [K, Se] = l(!1), [q, we] = l(() => jt(g, t, M, R)), [J, Te] = l(null), [Ee, Y] = l(!1), [X, De] = l(null), [Z, Oe] = l(), ke = c(null), Q = c(null), Ae = c(null), je = c(0), Me = c(q), Re = c(g), ze = c(t), Be = c(z), $ = c(q);
	$.current = q, o(() => {
		Se(!0), (0, Tt.deepEqual)(q, g) || S(q);
	}, []), o(() => {
		if (J || X) return;
		let e = !(0, Tt.deepEqual)(g, Re.current), n = !At(t, ze.current), r = z !== Be.current;
		if (e || n || r) {
			let n = jt(e ? g : q, t, M, R);
			(0, Tt.deepEqual)(n, q) || we(n);
		}
		Re.current = g, ze.current = t, Be.current = z;
	}, [
		g,
		t,
		M,
		z,
		R,
		J,
		X,
		q
	]), o(() => {
		!J && !(0, Tt.deepEqual)(q, Me.current) && (Me.current = q, S(q.filter((e) => e.i !== U.i)));
	}, [
		q,
		J,
		S,
		U.i
	]);
	let Ve = s(() => {
		if (!v) return;
		let e = H(q), t = W[1];
		return e * N + (e - 1) * P[1] + t * 2 + "px";
	}, [
		v,
		q,
		N,
		P,
		W
	]), He = a((e, t, n, r) => {
		let i = $.current, a = _e(i, e);
		if (!a) return;
		let o = {
			w: a.w,
			h: a.h,
			x: a.x,
			y: a.y,
			i: e
		};
		ke.current = ve(a), Ae.current = i, Te(o), C(i, a, a, null, r.e, r.node);
	}, [C]), Ue = a((e, t, n, r) => {
		let i = $.current, a = ke.current, o = _e(i, e);
		if (!o) return;
		let s = {
			w: o.w,
			h: o.h,
			x: o.x,
			y: o.y,
			i: e
		}, c = G(i, o, t, n, !0, V, z, M, B);
		ee(c, a, o, s, r.e, r.node), we(R.compact(c, M)), Te(s);
	}, [
		V,
		z,
		M,
		B,
		R,
		ee
	]), We = a((e, t, n, r) => {
		if (!J) return;
		let i = $.current, a = ke.current, o = _e(i, e);
		if (!o) return;
		let s = G(i, o, t, n, !0, V, z, M, B), c = R.compact(s, M);
		w(c, a, o, null, r.e, r.node);
		let l = Ae.current;
		ke.current = null, Ae.current = null, Te(null), we(c), l && !(0, Tt.deepEqual)(l, c) && S(c);
	}, [
		J,
		V,
		z,
		M,
		B,
		R,
		w,
		S
	]), Ge = a((e, t, n, r) => {
		let i = $.current, a = _e(i, e);
		a && (Q.current = ve(a), Ae.current = i, Y(!0), te(i, a, a, null, r.e, r.node));
	}, [te]), qe = a((e, t, n, r) => {
		let i = $.current, a = Q.current, { handle: o } = r, s = !1, c, l, [u, d] = xe(i, e, (e) => (c = e.x, l = e.y, [
			"sw",
			"w",
			"nw",
			"n",
			"ne"
		].includes(o) && ([
			"sw",
			"nw",
			"w"
		].includes(o) && (c = e.x + (e.w - t), t = e.x !== c && c < 0 ? e.w : t, c = c < 0 ? 0 : c), [
			"ne",
			"n",
			"nw"
		].includes(o) && (l = e.y + (e.h - n), n = e.y !== l && l < 0 ? e.h : n, l = l < 0 ? 0 : l), s = !0), V && !B && ge(i, {
			...e,
			w: t,
			h: n,
			x: c ?? e.x,
			y: l ?? e.y
		}).filter((t) => t.i !== e.i).length > 0 && (l = e.y, n = e.h, c = e.x, t = e.w, s = !1), e.w = t, e.h = n, e));
		if (!d) return;
		let f = u;
		s && c !== void 0 && l !== void 0 && (f = G(u, d, c, l, !0, V, z, M, B));
		let p = {
			w: d.w,
			h: d.h,
			x: d.x,
			y: d.y,
			i: e,
			static: !0
		};
		T(f, a, d, p, r.e, r.node), we(R.compact(f, M)), Te(p);
	}, [
		V,
		z,
		M,
		B,
		R,
		T
	]), Je = a((e, t, n, r) => {
		let i = $.current, a = Q.current, o = _e(i, e), s = R.compact(i, M);
		E(s, a, o ?? null, null, r.e, r.node);
		let c = Ae.current;
		Q.current = null, Ae.current = null, Te(null), Y(!1), we(s), c && !(0, Tt.deepEqual)(c, s) && S(s);
	}, [
		M,
		R,
		E,
		S
	]), Ye = a(() => {
		let e = $.current;
		if (!e.some((e) => e.i === U.i)) {
			De(null), Te(null), Oe(void 0);
			return;
		}
		we(R.compact(e.filter((e) => e.i !== U.i), M)), De(null), Te(null), Oe(void 0);
	}, [
		U.i,
		M,
		R
	]), Xe = a((e) => {
		if (e.preventDefault(), e.stopPropagation(), kt && !e.nativeEvent.target?.classList.contains(Ot)) return !1;
		let t = he ? he(e.nativeEvent) : O(e);
		if (t === !1) return X && Ye(), !1;
		let { dragOffsetX: r = 0, dragOffsetY: i = 0, ...a } = t ?? {}, o = {
			...U,
			...a
		}, s = e.currentTarget.getBoundingClientRect(), c = {
			cols: M,
			margin: P,
			maxRows: re,
			rowHeight: N,
			containerWidth: n,
			containerPadding: W
		}, l = le(c), u = L(o.w, l, P[0]), d = L(o.h, N, P[1]), f = u / 2, p = d / 2, m = e.clientX - s.left + r - f, h = e.clientY - s.top + i - p, g = Math.max(0, m), _ = Math.max(0, h), v = {
			left: g / be,
			top: _ / be,
			e: e.nativeEvent
		};
		if (X) Z && (Z.left !== v.left || Z.top !== v.top) && Oe(v);
		else {
			let e = de(c, _, g, o.w, o.h);
			De(/* @__PURE__ */ (0, wt.jsx)("div", {}, o.i)), Oe(v), we([...$.current.filter((e) => e.i !== o.i), {
				...o,
				x: e.x,
				y: e.y,
				static: !1,
				isDraggable: !0
			}]);
		}
	}, [
		X,
		Z,
		U,
		he,
		O,
		Ye,
		be,
		M,
		P,
		re,
		N,
		n,
		W
	]), Ze = a((e) => {
		e.preventDefault(), e.stopPropagation(), je.current--, je.current < 0 && (je.current = 0), je.current === 0 && Ye();
	}, [Ye]), Qe = a((e) => {
		e.preventDefault(), e.stopPropagation(), je.current++;
	}, []), $e = a((e) => {
		e.preventDefault(), e.stopPropagation();
		let t = $.current, n = t.find((e) => e.i === U.i);
		je.current = 0, Ye(), D(t, n, e.nativeEvent);
	}, [
		U.i,
		Ye,
		D
	]), et = a((e, t) => {
		if (!e || !e.key) return null;
		let r = _e(q, String(e.key));
		if (!r) return null;
		let i = typeof r.isDraggable == "boolean" ? r.isDraggable : !r.static && ie, a = typeof r.isResizable == "boolean" ? r.isResizable : !r.static && ce, o = r.resizeHandles || [...ue], s = i && ae && r.isBounded !== !1, c = fe;
		return /* @__PURE__ */ (0, wt.jsx)(Et, {
			containerWidth: n,
			cols: M,
			margin: P,
			containerPadding: W,
			maxRows: re,
			rowHeight: N,
			cancel: oe,
			handle: I,
			onDragStart: He,
			onDrag: Ue,
			onDragStop: We,
			onResizeStart: Ge,
			onResize: qe,
			onResizeStop: Je,
			isDraggable: i,
			isResizable: a,
			isBounded: s,
			useCSSTransforms: ye && K,
			usePercentages: !K,
			transformScale: be,
			positionStrategy: p,
			dragThreshold: se,
			w: r.w,
			h: r.h,
			x: r.x,
			y: r.y,
			i: r.i,
			minH: r.minH,
			minW: r.minW,
			maxH: r.maxH,
			maxW: r.maxW,
			static: r.static,
			droppingPosition: t ? Z : void 0,
			resizeHandles: o,
			resizeHandle: c,
			constraints: h,
			layoutItem: r,
			layout: q,
			children: e
		}, r.i);
	}, [
		q,
		n,
		M,
		P,
		W,
		re,
		N,
		oe,
		I,
		He,
		Ue,
		We,
		Ge,
		qe,
		Je,
		ie,
		ce,
		ae,
		ye,
		K,
		be,
		p,
		se,
		Z,
		ue,
		fe,
		h
	]), tt = () => J ? /* @__PURE__ */ (0, wt.jsx)(Et, {
		w: J.w,
		h: J.h,
		x: J.x,
		y: J.y,
		i: J.i,
		className: `react-grid-placeholder ${Ee ? "placeholder-resizing" : ""}`,
		containerWidth: n,
		cols: M,
		margin: P,
		containerPadding: W,
		maxRows: re,
		rowHeight: N,
		isDraggable: !1,
		isResizable: !1,
		isBounded: !1,
		useCSSTransforms: ye,
		transformScale: be,
		constraints: h,
		layout: q,
		children: /* @__PURE__ */ (0, wt.jsx)("div", {})
	}) : null;
	return /* @__PURE__ */ (0, wt.jsxs)("div", {
		ref: x,
		className: Ct(Ot, y),
		style: {
			height: Ve,
			...b
		},
		onDrop: pe ? $e : void 0,
		onDragLeave: pe ? Ze : void 0,
		onDragEnter: pe ? Qe : void 0,
		onDragOver: pe ? Xe : void 0,
		children: [
			i.Children.map(t, (e) => i.isValidElement(e) ? et(e) : null),
			pe && X && et(X, !0),
			tt()
		]
	});
}
//#endregion
export { D as a, E as i, Je as n, _ as o, ce as r, Mt as t };
